import { component, prop } from '../../../decorators';

@component({
   name: 'Range',
   watch: {
      value(val) {
         this.number = val;
      },
      max(max) {
         this.number = Math.min(this.number, max);
      },
      min(min) {
         this.number = Math.max(this.number, min);
      }
   }
})
export default class Range {
   @prop({ type: Number, default: Number.MAX_VALUE}) max
   @prop({ type: Number, default: 0}) min
   @prop({ type: Number, required: true }) value

   number = 0

   increment() {
      this.$emit('change', ++this.number);
   }
   decrement() {
      this.$emit('change', --this.number);
   }
}
